import { IconBuildingFactory2 } from "@tabler/icons-react"

import { NavbarOptionButton } from "@/components/generic/SideNavBar/components/NavbarOptionButton"

interface NavbarDevToolsButtonProps {
  isSelected: boolean
  isSidebarMenuExpanded: boolean
}

export function NavbarDevToolsButton({
  isSelected,
  isSidebarMenuExpanded,
}: NavbarDevToolsButtonProps) {
  if (process.env.NEXT_PUBLIC_SHOW_DEV_TOOLS != "true") return null

  return (
    <NavbarOptionButton
      icon={IconBuildingFactory2}
      isSelected={isSelected}
      isSidebarMenuExpanded={isSidebarMenuExpanded}
      label="Dev Tools"
      href="/dev"
      testID="sidenavbar-devtools-btn"
    />
  )
}
